import React, { useContext } from 'react';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import { FormControlLabel, Stack, Switch } from '@mui/material';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonButton from 'component/Argon/ArgonButton';

import DashboardLayout from 'layout/LayoutContainers/DashboardLayout';

import DashboardNavbar from 'component/Navbars/DashboardNavbar';
import NLExtContext from './ContextRapidNLCodeExt';

import ArgonTypography from 'component/Argon/ArgonTypography';

import {
  SelectPkg,
  InputEmployer,
  InputEmployerId,
  InputAddress1,
  AutoCompleteDistrict,
  FormField,
} from 'component/basicForm';

function LayoutNLExt() {
  const { alcode, setAlcode, ...state } = useContext(NLExtContext);

  const onCommit = (value) => {
    if (value) {
      const curr = value;
      state.setArea(curr?.amphoe);
      state.setProvince(curr?.province);
      state.setZipcode(curr?.zipcode.toString());
    }
  };

  return (
    <ArgonBox mt={3} mb={8}>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={9}>
          <Card sx={{ overflow: 'visible' }}>
            <ArgonBox p={2} lineHeight={1}>
              <ArgonBox>
                <ArgonTypography variant="h6" fontWeight="medium">
                  ต่ออายุกรมธรรม์
                </ArgonTypography>
                <ArgonTypography variant="button" fontWeight="regular" color="text">
                  ตามมติ 5 กรกฎาคม 2566
                </ArgonTypography>
              </ArgonBox>
              <ArgonBox mt={3}>
                <Grid container spacing={1}>
                  {/* <Grid item xs={12} sm={12}>
                      <PickerPolicyDate value={state.policyDate} setValue={state.setPolicyDate} />
                    </Grid> */}
                  <Grid item xs={12} sm={12}>
                    <SelectPkg value={state.pkg} setValue={state.setPkg} />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Stack direction="row">
                      <FormField
                        ml={0}
                        placeholder="หมายเลขประจำตัวคนต่างด้าว 13 หลัก"
                        value={alcode}
                        onChange={(v) => setAlcode(v.target.value)}
                      />
                      <ArgonButton
                        disabled={state.disabled}
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={state.getNamelist}
                        sx={{ whiteSpace: 'nowrap', ml: 1 }}
                      >
                        ตรวจสอบ
                      </ArgonButton>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                  <ArgonTypography component="label" variant="body2" fontWeight="bold">
                    ส่วนที่ 2: ที่อยู่
                  </ArgonTypography>
                  {/* <Stack direction="row" spacing={1}>
                    <ArgonButton
                      variant={state.toggle === true ? 'contained' : 'outlined'}
                      color="info"
                      onClick={() => state.setToggle(true)}
                    >
                      ใช้ที่อยู่ตามที่สมัคร
                    </ArgonButton>
                    <ArgonButton
                      variant={state.toggle === true ? 'outlined' : 'contained'}
                      color="info"
                      onClick={() => state.setToggle(false)}
                    >
                      กำหนดที่อยู่นายจ้างเอง
                    </ArgonButton>
                  </Stack> */}
                </Grid>
                <>
                  <Grid item xs={12}>
                    <InputEmployer value={state.employer} setValue={state.setEmployer} />
                  </Grid>
                  <Grid item xs={12}>
                    <InputEmployerId value={state.employerId} setValue={state.setEmployerId} />
                  </Grid>
                  <Grid item xs={12}>
                    <InputAddress1 value={state.address1} setValue={state.setAddress1} />
                  </Grid>
                  <Grid item xs={12}>
                    <AutoCompleteDistrict value={state.district} onChange={state.setDistrict} onCommit={onCommit} />
                  </Grid>
                  <Grid item xs={12}>
                    <FormField placeholder="อำเภอ/เขต" disabled value={state.area} />
                  </Grid>
                  <Grid item xs={12}>
                    <FormField placeholder="จังหวัด" disabled value={state.province} />
                  </Grid>
                  <Grid item xs={12}>
                    <FormField placeholder="รหัสไปรษณีย์" disabled value={state.zipcode} />
                  </Grid>
                </>
              </ArgonBox>
            </ArgonBox>
            <ArgonBox px={2} mb={3}>
              <Stack direction="row" alignItems="end" justifyContent="flex-end">
                <ArgonBox mt={2}>
                  <ArgonButton
                    variant="gradient"
                    // disabled={state.isPass}
                    color="success"
                    size="small"
                    disabled={state.parseData?.length < 1 || !state?.addresed}
                    onClick={state.handleSubmit}
                  >
                    เพิ่มไปที่รถเช็น
                  </ArgonButton>
                </ArgonBox>
              </Stack>
            </ArgonBox>
          </Card>
        </Grid>
      </Grid>
    </ArgonBox>
  );
}

export default LayoutNLExt;
